import React from 'react';
import styled from 'styled-components';

const StyledIcon = styled.i`
  display: inline;
  height: 2rem;
  color: ${({ theme }) => theme.colors.brandPrimary};
  font-size: 1.875em;
  vertical-align: top;
  justify-content: center;
  margin-right: 0.5rem;
  padding-left: 0.1rem;
  padding-right: 0.1rem;
`;

interface SupportIconProps {
  iconType?: string;
}

function SupportIcon({
  iconType = 'bi bi-check-circle-fill',
}: Readonly<SupportIconProps>) {
  return <StyledIcon className={`${iconType}`}></StyledIcon>;
}

export default SupportIcon;
